import { Alert } from "@interstate/components/Alert";
import { StyledContainerAlert } from "./styled";
import { ErrorMessages } from "@coxauto-ui/cxm/communications/util";

export interface TextOptInPendingAlertProps {
  isTextOptInPending: boolean;
}

export function TextOptInPendingAlert({
  isTextOptInPending
}: TextOptInPendingAlertProps) {
  if (!isTextOptInPending) {
    return null;
  }

  return (
    <StyledContainerAlert>
      <Alert id="TextOptInPendingWarning" role="warning" type="caution">
        {ErrorMessages.PENDING_CUSTOMER_OPT_IN_WARNING}
      </Alert>
    </StyledContainerAlert>
  );
}
